import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/maintenance_dob/targetedMonthlyVisitsReportActions'
import * as api from '../../../api/reports/maintenance_dob/targetedMonthlyVisitsReport'

function* targetedMonthlyVisitsReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList, action.filters)
    yield put({ type: constants.TARGETED_MONTHLY_VISITS_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.TARGETED_MONTHLY_VISITS_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* targetedMonthlyVisitsReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.TARGETED_MONTHLY_VISITS_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.TARGETED_MONTHLY_VISITS_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */

function* watchtargetedMonthlyVisitsReportGetJobList() {
  yield takeLatest(
    constants.TARGETED_MONTHLY_VISITS_REPORT_GET_JOB_LIST.ACTION,
    targetedMonthlyVisitsReportGetJobList
  )
}

function* watchtargetedMonthlyVisitsReportGetFullReport() {
  yield takeLatest(
    constants.TARGETED_MONTHLY_VISITS_REPORT_GET_FULL_REPORT.ACTION,
    targetedMonthlyVisitsReportGetFullReport
  )
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchtargetedMonthlyVisitsReportGetFullReport),
    fork(watchtargetedMonthlyVisitsReportGetJobList)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/maintenance_dob/targetedMonthlyVisitsReportSaga.js